import { render } from "./TournamentPlay.vue?vue&type=template&id=782e1331"
import script from "./TournamentPlay.vue?vue&type=script&lang=js"
export * from "./TournamentPlay.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/happy-quiz-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__